import { Color } from "@tiptap/extension-color";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TextStyle from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import React, { useEffect } from "react";
import { BackColor } from "./back-color";

import "./quill.dms.css";

function Toolbar({ editor }) {
  if (!editor) return null;

  return (
    <div className="tt-toolbar">
      <div className="tt-toolbar-group">
        <select
          onChange={e => {
            e.preventDefault();
            const level = parseInt(e.target.value);
            if (level === 0) {
              editor.chain().focus().setParagraph().run();
            } else {
              editor.chain().focus().toggleHeading({ level }).run();
            }
          }}
          value={
            editor.isActive("heading", { level: 1 })
              ? 1
              : editor.isActive("heading", { level: 2 })
                ? 2
                : editor.isActive("heading", { level: 3 })
                  ? 3
                  : 0
          }>
          <option value={0}>Normal</option>
          <option value={1}>Heading 1</option>
          <option value={2}>Heading 2</option>
          <option value={3}>Heading 3</option>
        </select>
      </div>
      <div className="tt-toolbar-group">
        <button
          onClick={e => {
            e.preventDefault();
            editor.chain().focus().toggleBold().run();
          }}
          className={editor.isActive("bold") ? "active" : ""}>
          Bold
        </button>
        <button
          onClick={e => {
            e.preventDefault();
            editor.chain().focus().toggleItalic().run();
          }}
          className={editor.isActive("italic") ? "active" : ""}>
          Italic
        </button>
        <button
          onClick={e => {
            e.preventDefault();
            editor.chain().focus().toggleUnderline().run();
          }}
          className={editor.isActive("underline") ? "active" : ""}>
          Underline
        </button>
      </div>

      {/* <div className="tt-toolbar-group">
        <button
          onClick={() => {
            const url = window.prompt("URL");
            if (url) {
              editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();
            }
          }}
          className={editor.isActive("link") ? "active" : ""}>
          Link
        </button>
        <button
              onClick={() => {
                const url = window.prompt("Image URL");
                if (url) {
                  editor.chain().focus().setImage({ src: url }).run();
                }
              }}>
              Image
            </button>
      </div> */}

      <div className="tt-toolbar-group">
        <button
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          className={editor.isActive("orderedList") ? "active" : ""}>
          Numbered List
        </button>
        <button
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          className={editor.isActive("bulletList") ? "active" : ""}>
          Bullet List
        </button>
      </div>
    </div>
  );
}

interface MyEditorProps {
  content?: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
}

export function MyEditor({ content = "", readOnly = false, onChange }: MyEditorProps) {
  const editor = useEditor({
    editable: !readOnly,
    parseOptions: {
      preserveWhitespace: true,
    },
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      if (onChange) {
        onChange(html);
      }
    },
    content,
    extensions: [
      StarterKit,
      Underline,
      TextStyle,
      Color.configure({
        types: ["textStyle"],
      }),
      BackColor,
      Table.configure({
        resizable: false,
      }),
      TableCell,
      TableHeader,
      TableRow,
    ],
    editorProps: {
      attributes: {
        class: "tt-editor-content", // not working, setting CSS directly
      },
    },
  });

  useEffect(() => {
    if (editor && content !== editor.getHTML()) {
      editor.commands.setContent(content);
    }
  }, [content]);

  return (
    <>
      {!readOnly && <Toolbar editor={editor} />}
      <EditorContent editor={editor} className="tt-editor" />
    </>
  );
}
